type param = {
  domain?: string
  path: string
  query?: any
}

const formatGetUrl = ({ path, query }: param) => {
  const queryString = Object.entries(query).reduce(
    (acc: string, [key, value]) => (!value ? acc : `${acc}&${key}=${value}`),
    ''
  )
  return `${path}?${queryString}`
}

export default formatGetUrl
